import {
  transformPropertyDetails,
  transformCaseDetails,
  dedupeBoundingBoxResults,
} from './api-transform';

import { apiBase } from '../config';

export const searchLocations = (searchTerm: string) => {
  return fetch(`${apiBase}/v1/searchList`, {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      szKeyword: searchTerm,
    }),
  })
    .then(r => r.json())
    .then(r => {
      if (r && r.response && Array.isArray(r.response.address)) {
        return r.response.address;
      }
      return [];
    })
    .catch(() => {
      return [];
    });
};

export const getLocationDetails = (propertyId: string) => {
  return fetch(`${apiBase}/v1/propertyDetails`, {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      idProperty: propertyId,
    }),
  })
    .then(response => {
      return response.json();
    })
    .then(body => transformPropertyDetails(body, propertyId));
};

export const getLocationDetailsByCaseNumber = (caseNumber: string) => {
  return fetch(`${apiBase}/v1/fetchPropertyByCaseNo`, {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      caseNumber,
    }),
  })
    .then(response => {
      return response.json();
    })
    .then(body => transformCaseDetails(body));
};

export const saveConversion = (data: any) => {
  return fetch(`${apiBase}/v1/conversionForm`, {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then(response => {
      return response.json();
    })
    .then(response => {
      const result: any = response.response;

      return Promise.resolve(result);
    });
};

export const resolveAddress = (address: string, geocoder: Function) => {
  return new Promise(resolve => {
    geocoder.geocode({ address }, (results, status) => {
      const response = {
        lat: 0,
        lng: 0,
      };

      if (status === 'OK') {
        const firstLocation = results[0];
        if (firstLocation) {
          response.lat = firstLocation.geometry.location.lat();
          response.lng = firstLocation.geometry.location.lng();
        }
      }
      resolve(response);
    });
  });
};

export const findNearbyLocations = (
  postCode: string = '2620',
  geocoder: Function
) => {
  return fetch(`${apiBase}/v1/fetchMapPropertyByPostCode`, {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ postCode }),
  })
    .then(response => {
      return response.json();
    })
    .then(response => {
      const result: any = response.response.map(item => {
        const address = `${`${item.Vejnavn} ${item.Husnummer} ${item.Sidedoer}`.trim()}, ${
          item.Postnummer
        } ${item.Bynavn}`;
        return resolveAddress(address, geocoder).then(({ lat, lng }) => {
          return Promise.resolve({
            ...item,
            address,
            lat,
            lng,
          });
        });
      });

      return Promise.all(result);
    });
};

export const findLocationsByBoundingBox = (bb: any) => {
  return fetch(`${apiBase}/v1/fetchAddressByLatLongRange`, {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(bb),
  })
    .then(response => {
      return response.json();
    })
    .then(body => dedupeBoundingBoxResults(body, bb));
};
